import { GAME_CONSTANTS } from '@ppwr/convex/shared/constants'

type HandOutcome = 'free_fold' | 'win' | 'loss'

const outcomeEmoji: Record<HandOutcome, string> = {
  // free_fold: '⬛',
  free_fold: '✖️',
  win: '🟢',
  loss: '🔴'
}

export function formatDaily10Score(chips: number): string {
  if (chips >= 1000) {
    const k = chips / 1000
    return k % 1 === 0 ? `${k}k` : `${k.toFixed(1)}k`
  }
  return chips.toString()
}

export function formatDaily10Date(dateStr: string): string {
  const [, month, day] = dateStr.split('-').map(Number)
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return `${monthNames[month - 1]} ${String(day).padStart(2, '0')}`
}

export function buildDaily10ShareMessage(opts: {
  handOutcomes: HandOutcome[]
  playedDate: string
  finalChips: number
  streak: number
}): string {
  const { DEFAULT_GAME_NAME_PERSONALIZED } = GAME_CONSTANTS.DAILY10_CONSTANTS
  const { DEFAULT_SHARE_SITE_CTA } = GAME_CONSTANTS

  const { handOutcomes, playedDate, finalChips, streak } = opts
  const grid = handOutcomes.map((o) => outcomeEmoji[o]).join('')
  return `🃏 ${DEFAULT_GAME_NAME_PERSONALIZED} - ${formatDaily10Date(playedDate)}\n${grid}\nScore: ${formatDaily10Score(finalChips)} | Streak: ${streak}\n\n${DEFAULT_SHARE_SITE_CTA}`
}
